import styles from "./login.module.css"
import { useState } from "react";
import logo from "../../assets/images/logo.png"
import { Link, useLocation } from "react-router-dom";

const Login = () => {
  const { search } = useLocation()
  const [data, setData] = useState<{ email: string, senha: string }>({ senha: "", email: "" })

  const onHandleChange = (event: { target: { name: string, value: string } }) => {
    setData({ ...data, [event.target.name]: event.target.value });
  }

  return (
    <div className={styles["container"]}>
      <form onSubmit={() => { }} className={styles["login-box"]}>
        <div>
          <div className={styles["logo"]}><img src={logo} alt="" /></div>
          <h2>Instituto Nacional de Meteorologia</h2>
          <span>Bem-vindo!</span>
          <div className={styles["input-group"]}>
            <label>Email </label>
            <input value={data.email} onChange={onHandleChange} name="email" type="text" placeholder="user@inam.com" />
          </div>
          <div className={styles["input-group"]}>
            <label>Senha </label>
            <input value={data.senha} onChange={onHandleChange} name="senha" type="text" placeholder="inam258" />
          </div>
          <div className={styles["options"]}>
            <label>
              <input type="checkbox" /> <span>Lembrar-me</span>
            </label>
          </div>
          {/* <button className={styles["signin"]} disabled={loading}>{loading ? <CircularProgress size={25} color={"primary"} /> : "Entrar"}</button> */}
          <Link to={`/forecast${search}`}>
            <button className={styles["signin"]}>Entrar</button>
          </Link>
        </div>
      </form>
    </div>
  );
};

export { Login };